'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var model = require('./../models/vote-option');

module.exports = Backbone.Collection.extend({
    model: model,
    currentModel: undefined,
    maxVotes: 0,
    /**
     *
     * @param attrs
     * @param options
     */
    initialize: function (attrs, options) {
        // this.controller = options.controller;
        if(typeof options.maxVotes !== 'undefined')
            this.maxVotes = parseInt(options.maxVotes, 10) || 0;
    },
    /**
     * [comparator description]
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    comparator: function(item) {
        return item.get('name').toLowerCase();
    },
    /**
     * clearVoteCount
     *
     * Set all models to zero
     */
    clearVoteCount: function (params) {
        params = params || {};
        _.each(this.models, function (model) {
            model.set({voteCount: 0}, params);
        });
    },
    /**
     *
     * @param id
     */
    setSelected: function(id){
        this.each(function(model) {
            model.set( {selected: false}, {silent: true} );
        });
        this.get(id).set( {selected: true} );
    },
    /**
     *
     */
    clearSelected: function(){
        this.each(function(model) {
            model.set( {selected: false}, {silent: true} );
        });
    },
    /**
     *
     * @returns {*|Mixed}
     */
    getSelected: function () {
        return this.findWhere({selected: true});
    },
    /**
     *
     * @param id
     */
    setCurrent: function(id){
        var bId = (id > this.length)? this.length : id ;
        this.currentModel = this.get(bId);
    },
    /**
     *
     */
    getCurrent: function(){
        return this.currentModel || this.at(0);
    },
    /**
     *
     */
    setNext: function (){
        var newIndex = (this.indexOf(this.getCurrent()) === (this.length - 1))? 0 : this.indexOf(this.getCurrent()) + 1 ;
        this.setCurrent(this.at(newIndex).get('id'));
        return this;
    },
    /**
     *
     */
    getNext: function(){
        var newIndex = (this.indexOf(this.getCurrent()) === (this.length - 1))? 0 : this.indexOf(this.getCurrent()) + 1 ;
        return this.at(newIndex);
    },
    /**
     *
     */
    getPrev: function(){
        var newIndex = (this.indexOf(this.getCurrent()) === 0)? (this.length - 1) : this.indexOf(this.getCurrent()) - 1 ;
        return this.at(newIndex);
    },
    /**
     *
     */
    setPrev: function() {
        var newIndex = (this.indexOf(this.getCurrent()) === 0)? (this.length - 1) : this.indexOf(this.getCurrent()) - 1 ;
        this.setCurrent(this.at(newIndex).get('id'));
        return this;
    },
    /**
     *
     * @returns {Array}
     */
    getVoteString: function() {
        return _.mapValues(_.indexBy(this.toJSON(), 'id'), function (value) {
            if(parseInt(value.voteCount, 10) > 0) {
                return parseInt(value.voteCount, 10);
            } else {
                return false;
            }
        });
    },
    updateVoteOptions: function (voteString) {
        var n = 0; // eslint-disable-line

        _.each(voteString, function (value, key){
            n++; // eslint-disable-line

            var model = this.get(key);

            if(!_.isUndefined(model)){
                model.set({
                    voteCount: parseInt(value, 10),
                    lastSubmitted: parseInt(value, 10)
                });
                
            }
        }.bind(this));

    },
    /**
     *
     * @return {Array}
     */
    getAllWithCount: function () {
        var votes = [];
        _.each(this.models, function(model) {
            if(model.get('voteCount')>0) {
                votes.push(model.get('id'));
            }
        });
        return votes;
    },
    /**
     * Add up the voteCount of all options
     * @return {Number}
     */
    getTotal: function(){
        var total = 0;

        _.each(this.models, function(model) {
            total += model.get('voteCount');
        });

        return total;
    },
    /**
     * Add up the voteCount of all options
     * @return {Number}
     */
    getTotalSubmitted: function(){
        var total = 0;

        _.each(this.models, function(model) {
            total += model.get('lastSubmitted');
        });

        return total;
    },
    /**
     * Check if any of the models have changed since last submitted
     * @return {Boolean}
     */
    hasChangedVotes: function() {
        return this.models.some(function(model) {
            return model.get('lastSubmitted') !== model.get('voteCount');
        });
    }
});



// WEBPACK FOOTER //
// ./app/scripts/collections/vote-option.js